
import { defineComponent } from 'vue'
import { EpbButton } from './shared/epb-button'

export default defineComponent({
  name: 'EditableLabel',
  components: {
    EpbButton,
  },
  props: {
    value: String,
    placeholder: String,
    handleEditable: {
      type: Boolean,
      default: true,
    },
    editable: Boolean,
    invalid: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      baseClass: 'epb-editable-label',
      /*
       * Array needed to avoid jumping cursor problems
       * https://medium.com/dont-leave-me-out-in-the-code/fc9c52622b3
       */
      inputValue: [''],
      active: false,
    }
  },
  computed: {
    classes(): (string | Record<string, boolean>)[] {
      return [
        `${this.baseClass}`,
        {
          [`${this.baseClass}--active`]: this.active,
          [`${this.baseClass}--editable`]: this.editable,
          [`${this.baseClass}--invalid`]: this.invalid,
          [`${this.baseClass}--disabled`]: this.disabled,
        },
      ]
    },
  },
  watch: {
    value: {
      handler(value: string): void {
        this.inputValue[0] = value
      },
      immediate: true,
    },
    editable(editable: boolean): void {
      this.$nextTick(() => {
        if (!editable) {
          this.blur()
        } else if (this.handleEditable) {
          this.focus()
        }
      })
    },
  },
  methods: {
    focus(): void {
      // Public
      this.$refs.input.focus()
    },
    blur(): void {
      // Public
      this.$refs.input.blur()
    },
    onInputFocus(): void {
      this.active = true
      this.$emit('focus')
    },
    onInputBlur(): void {
      this.active = false
      this.$refs.input.scrollLeft = 0
      this.$emit('blur')
      if (this.handleEditable) {
        this.$emit('updateEditable', false)
      }
    },
  },
})
